module.exports = __webpack_public_path__ + "media/images/telefono-47da3002e110760846a23d127e0e6bab.svg";